import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T, { specularHost } from '../../home-new/tokens'
import Reveal from '../../home-new/Reveal'

// Help banner — a light-blue rounded strip: headset illustration + heading +
// text on the left, a blue "ติดต่อทีมงาน" CTA on the right.
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '10px 0 70px',
    background: T.color.surface,
    [theme.breakpoints.down('sm')]: { padding: '0 0 44px' },
  },
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: '28px',
    background: 'linear-gradient(180deg, #EAF4FF 0%, #F2F8FF 100%)',
    border: `1px solid ${T.color.line}`,
    borderRadius: 28,
    padding: '28px 40px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
      padding: '28px 22px',
      gap: '18px',
    },
  },
  art: {
    flexShrink: 0,
    width: 96,
    height: 96,
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: { width: 78, height: 78 },
  },
  copy: { flexGrow: 1 },
  title: {
    fontFamily: T.font.heading,
    fontSize: 26,
    fontWeight: 700,
    color: T.color.ink,
    margin: '0 0 6px',
    [theme.breakpoints.down('sm')]: { fontSize: 20 },
  },
  sub: {
    fontFamily: T.font.body,
    fontSize: 16,
    color: T.color.muted,
    lineHeight: 1.6,
    margin: 0,
    [theme.breakpoints.down('sm')]: { fontSize: 14 },
  },
  btn: {
    ...specularHost,
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 52,
    padding: '0 40px',
    borderRadius: T.radius.pill,
    background: T.gradient.blue,
    color: T.color.onBrand,
    fontFamily: T.font.heading,
    fontSize: 17,
    fontWeight: 600,
    textDecoration: 'none',
    boxShadow: '0 8px 22px rgba(0,102,204,0.26)',
    '&:hover': { transform: 'translateY(-2px)', color: T.color.onBrand },
    [theme.breakpoints.down('sm')]: { width: '100%' },
  },
}))

const HelpBanner = () => {
  const classes = useStyles()
  const { t } = useTranslation('services')
  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <div className={classes.banner}>
            <img
              className={classes.art}
              src="/static/img/service-new/help.png"
              alt=""
              aria-hidden="true"
              loading="lazy"
            />
            <div className={classes.copy}>
              <h2 className={classes.title}>{t('new.help.title')}</h2>
              <p className={classes.sub}>{t('new.help.sub')}</p>
            </div>
            <a
              href="https://line.me/R/ti/p/@shippop"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.btn}
            >
              {t('new.help.cta')}
            </a>
          </div>
        </Reveal>
      </Container>
    </section>
  )
}

export default HelpBanner
